export default {
  'messages': {
    'en-US': {
      'Home_Menu': 'Home',
      'AddTransfers_Menu': 'Add Transfers To Run',
      'Parties_Menu': 'Parties',
      'CreditTransfers_Menu': 'Credit Transfers',
      'CreditTransferPaymentRuns_Menu': 'Credit Transfer Payment Runs',
      'Submit': 'Submit',
      'Reset': 'Reset',
      'Delete': 'Delete',
      'Are you sure you want to delete this item?': 'Are you sure you want to delete this item?',
      'No results': 'No results',
      'Close': 'Close',
      'Cancel': 'Cancel',
      'Updated': 'Updated',
      'Field': 'Field',
      'Value': 'Value',
      'Filters': 'Filters',
      'Filter': 'Filter',
      'Data unavailable': 'Data unavailable',
      'Loading...': 'Loading...',
      'No data available': 'No data available',
      'Deleted': 'Deleted',
      'Please, insert a value bigger than zero!': 'Please, insert a value bigger than zero!',
      'Please type something': 'Please type something',
      'Field is required': 'Field is required',
      'Records per page:': 'Records per page:',
    }
  },
  'dates': {
    'en-US': {
      short: {
        year: '2-digit', month: '2-digit', day: '2-digit'
      },
      long: {
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric'
      }
    }
  }
};
